module.exports = __webpack_public_path__ + "img/1578731642.89a509f6.jpg";